module.exports = __webpack_public_path__ + "img/source.a6aa7e2b.svg";